import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormHelperService} from '@services/form-helper.service';
import {ShortLinkConfig} from '@components/form-field/form-date-range/date-range-short-link';
import {FormControl} from '@angular/forms';
import {map} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {DropdownDirective} from '@lab365/common';


@Component({
    selector: 'app-form-date-range-dropdown',
    templateUrl: './form-date-range-dropdown.component.html',
    styleUrls: ['./form-date-range-dropdown.component.scss']
})
export class FormDateRangeDropdownComponent implements OnInit, OnDestroy {

    @Input() fbControlDateFrom = new FormControl('');
    @Input() fbControlDateTo = new FormControl('');
    @Input() shortLinksConfig: ShortLinkConfig[];

    public shadowControl = new FormControl('');
    public shadowControlFrom = new FormControl('');
    public shadowControlTo = new FormControl('');

    @ViewChild(DropdownDirective) dropdown: DropdownDirective;

    ngOnInit() {
        this.initValues();

        combineLatest([
            this.fbControlDateFrom.valueChanges,
            this.fbControlDateTo.valueChanges,
        ]).pipe(
            map((values: string[]) => {
                const prefix = (values[0] && !values[1]) ? 'от ' : (!values[0] && values[1] ? 'до ' : '');
                return prefix + values.filter(v => Boolean(v)).filter((v, index, array) => index === array.lastIndexOf(v)).join(' - ');
            }),
            untilDestroyed(this),
        ).subscribe((dateValue: string) => {
            this.shadowControl.patchValue(dateValue);
        });

        if (!this.shortLinksConfig) {
            this.shortLinksConfig = [
                {label: 'Сегодня'},
                {label: 'Вчера', daysShift: -1},
                {label: 'Неделя', daysShift: -7},
                {label: 'Месяц', monthsShift: -1},
                {label: 'Квартал', monthsShift: -3},
                {label: 'Год', monthsShift: -12},
            ];
        }
    }

    ngOnDestroy() {

    }

    apply() {
        this.fbControlDateFrom.patchValue(this.shadowControlFrom.valid ? this.shadowControlFrom.value : '');
        this.fbControlDateTo.patchValue(this.shadowControlTo.valid ? this.shadowControlTo.value : '');
        this.dropdown.close();
    }

    reset() {
        this.fbControlDateFrom.patchValue('');
        this.fbControlDateTo.patchValue('');
        this.dropdown.close();
    }

    onOpen() {
        this.initValues();
    }

    private initValues() {
        this.shadowControlFrom.patchValue(this.fbControlDateFrom.value);
        this.shadowControlTo.patchValue(this.fbControlDateTo.value);
        FormHelperService.makeClean(this.shadowControlFrom);
        FormHelperService.makeClean(this.shadowControlTo);
    }
}
